<template>
    <div class="get-address">
      <h1>What is your address?</h1>
      <v-card-text>
        <v-text-field
          ref="address"
          v-model="address"
          :rules="[
            () => !!address || 'This field is required',
            addressCheck
          ]"
          label="Address"
          placeholder="Snowy Rock Pl, San Diego"
          required
          variant="outlined"
        ></v-text-field>
        <v-btn
          v-if="address && (!place || address!==place.formatted_address)"
          color="primary"
          @click="fillInAddressFromText"
        >
          Use "{{ address }}"
        </v-btn>
      </v-card-text>
    </div>
    <!-- todo: remove when not needed <p v-if="place">{{ place }}</p> -->
    <!-- <p v-if="place">{{ place }}</p>
    <p v-if="address">{{ address }}</p> -->
</template>

<script>
  /* global google */
  export default {
    name: 'GetAddress',
    props: {
      companySlug: {
        type: String,
        default: 'mission'
      }
    },
    data() {
      return {
        address: '',
        place: null,
        autocomplete: null
      }
    },
    computed: {
      storageKey() {
        return `${this.companySlug}-place`;
      },
      google_map_url() {
        return 'https://maps.googleapis.com/maps/api/staticmap?size=325x256&amp;zoom=19&amp;scale=1&amp;style=feature:poi%7Cvisibility:off&amp;format=png&amp;maptype=satellite&amp;center='
        +this.place.geometry.location.lat+','+this.place.geometry.location.lng+'&amp;key=GAPIKEY'
      }
    },
    mounted() {
      // Load place from localStorage using company-prefixed key
      this.place = JSON.parse(localStorage.getItem(this.storageKey)) || null;

      this.$nextTick(() => {
        if(this.place) {
          // Emits an event to parent with the data
          this.$emit('send-place', this.place);
        }

        // Check if ref exists before trying to access it
        if (this.$refs.address && this.$refs.address.$el) {
          const inputElement = this.$refs.address.$el.querySelector('input');
          this.autocomplete = new google.maps.places.Autocomplete(
            inputElement,
            { types: ['geocode'] }  // This can be ['address'] if you want to limit to addresses only
          );
          this.autocomplete.addListener('place_changed', this.fillInAddress);
        }
      })
    },
    methods: {
      fillInAddressFromText() {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: this.address }, (res, status) => {
          if (status==='OK') {
            this.saveAddress(res[0]);
          }
        });
      },
      fillInAddress() {
        this.saveAddress(this.autocomplete.getPlace());
      },
      saveAddress(address) {
        // persist place to local storage using company-prefixed key
        localStorage.setItem(this.storageKey, JSON.stringify(address));
        // pull place from JSON storage object, otherwise lat/lng will return functions not values
        this.place = JSON.parse(localStorage.getItem(this.storageKey)) || null;
        this.address = this.place.formatted_address;
        // Emits an event to parent with the data
        this.$emit('send-place', this.place);
      },
      addressCheck() {
        // perform some validation on the address, return an error message if invalid
      },
    }
  }
  </script>